import { generateShopAssociatedKey } from "#/utils/keyHandler"

//
const cartKey = "yingqiyu_ziubao_shop_cart";
const cartShopIdKey = "yingqiyu_ziubao_shop_cart_shop_id";

export const setCart = (shopId, cart) => {
    /**
     * 
     */
    let cartShopId = localStorage.getItem(cartShopIdKey);

    if (cartShopId != null) {
        clearCart(cartShopId);
    }

    localStorage.setItem(cartShopIdKey, shopId)

    /**
     *
     */
    localStorage.setItem(generateShopAssociatedKey(shopId, cartKey), cart);
}

export const getCart = (shopId) => {
    let cartString = localStorage.getItem(generateShopAssociatedKey(shopId, cartKey));

    if (cartString) {
        return JSON.parse(cartString);
    }

    return [];
}

export const clearCart = (shopId) => {
    localStorage.removeItem(generateShopAssociatedKey(shopId, cartKey));
}